import * as React from 'react';
import ManuCompleteOrderPageView from '../layouts/ManuCompleteOrderPageView';
import { RowDataCompleted, RedesignReasons, ManuCompOrderFilterData } from 'src/reducers/completeorderfile';
import { ManufacturerData, TatData } from 'src/reducers/fileUpload';
import { UserDetail } from 'src/reducers/user';
// import { UserDetail } from '../../reducers/user';

export interface ManuCompleteOrderPageViewProps {
    onComponentDidMount: () => void;
    onComponentWillMount: (data: boolean) => void;
    completeOrderData: RowDataCompleted[];
    isDownloading: boolean;
    redesignReasons: RedesignReasons[];
    reload: () => void;
    onRowClick: (orderid: string, rowData: string) => void;
    onRowClickFbStatus: (orderid: string, rowData: string, feedbackreview: string) => void;
    onDownloadClick: (orderno: string, fileName: string) => void;
    onBulkDownload: (completedData: RowDataCompleted[] | RowDataCompleted) => void;
    onBulkDownloadIndividual: (completedData: RowDataCompleted[] | RowDataCompleted) => void;
    printClient: (completedData: RowDataCompleted) => void;
    onBulkDownloadStl: (completedData: RowDataCompleted[] | RowDataCompleted, filetype: string) => void;
    fromDate: (fromdate: string) => void;
    toDate: (todate: string) => void;
    dateFilter: () => void;
    dateReset: () => void;

    orderDataTat: TatData[];
    orderDataManufacturer: ManufacturerData[];
    approvalRequired: (array: Array<object>) => void;
    redesignRequest: (columns: Object) => void;
    openVideoPlayerURL: (fullPath: string[], fpath: string) => void;

    userInfo: UserDetail;

    redirectDesignReady: boolean;
    onFilterChange: (data: ManuCompOrderFilterData) => void;
     // Add missing props here
     failedFiles: Array<{ fname: string; orderno: string }>;
     showFailedFilesDialog: boolean;
     failedFilesMessage: string;
     closeFailedFilesDialog: () => void;
}

class ManuCompleteOrderPage extends React.Component<ManuCompleteOrderPageViewProps> {
    render() {
        return (
            <ManuCompleteOrderPageView
                completeOrderData={this.props.completeOrderData}
                isDownloading={this.props.isDownloading}
                redesignReasons={this.props.redesignReasons}
                reload={this.props.reload}
                onRowClick={this.props.onRowClick}
                onRowClickFbStatus={this.props.onRowClickFbStatus}
                onDownloadClick={this.props.onDownloadClick}
                onBulkDownload={this.props.onBulkDownload}
                onBulkDownloadIndividual={this.props.onBulkDownloadIndividual}
                printClient={this.props.printClient}
                onBulkDownloadStl={this.props.onBulkDownloadStl}
                fromDate={this.props.fromDate}
                toDate={this.props.toDate}
                dateFilter={this.props.dateFilter}
                dateReset={this.props.dateReset}
                orderDataTat={this.props.orderDataTat}
                orderDataManufacturer={this.props.orderDataManufacturer}
                approvalRequired={this.props.approvalRequired}
                redesignRequest={this.props.redesignRequest}
                openVideoPlayerURL={this.props.openVideoPlayerURL}
                userInfo={this.props.userInfo}
                redirectDesignReady={this.props.redirectDesignReady}
                onFilterChange={this.props.onFilterChange}
                // Add these new props
                failedFiles={this.props.failedFiles}
                showFailedFilesDialog={this.props.showFailedFilesDialog}
                failedFilesMessage={this.props.failedFilesMessage}
                closeFailedFilesDialog={this.props.closeFailedFilesDialog}
            />
        );
    }
    componentDidMount() {
        // const url: string = window.location.href;
        this.props.onComponentDidMount();
    }
    componentWillMount() {
        // const url: string = window.location.href;
        this.props.onComponentWillMount(this.props.redirectDesignReady);

    }
}

export default ManuCompleteOrderPage;



// WEBPACK FOOTER //
// ./src/components/ManuCompleteOrderPage/ManuCompleteOrderPage.tsx